<script lang="ts">
    import {FLAGS, TEMPLATE} from 'general/constants';
    import {dyData, modal} from 'general/store';

    import FlipItem from 'desktop/components/flipItem/FlipItem.svelte';
    import Theme from 'general/theme/Theme.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import Description from 'general/components/description/Description.svelte';
    import FireworksIcon from 'desktop/icons/Fireworks.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import Steps from 'desktop/components/steps/Steps.svelte';

    import s from './style.module.css';

    const fireworksIconSize = $dyData.flag === FLAGS.TYP_STEPS ? '56' : '64';
</script>

<FlipItem>
    <Theme template={TEMPLATE.CIRCLE} color={$dyData.side.subscribed.backgroundColor}>
        <div class={s.subscribed} style="margin-top: {$dyData.side.subscribed.marginTop || 0}">
            <CloseButton handleClick={modal.close} theme="dark" />
            <div class={s.icon} role="presentation">
                <FireworksIcon width={fireworksIconSize} height={fireworksIconSize} />
            </div>
            <Description value={$dyData.description?.subscribed} />
            {#if $dyData.flag === FLAGS.TYP_STEPS}
                <Steps />
            {/if}
            <DyButton
                type="button"
                color="dark"
                size="small"
                children="Continue Shopping"
                rounded={true}
                {...$dyData.mainButton?.subscribed || {}}
                onClick={modal.close}
            />
        </div>
    </Theme>
</FlipItem>
